module.exports = __webpack_public_path__ + "static/hateship-friendship-courtship-loveship-marriage-storycuts-c4240031102aa7d8b9532e7946717f1b.jpg";